import { Expose } from 'class-transformer'

export class EasyTradeTemplateSymbol {
  @Expose()
  symbol: string

  @Expose()
  symbolImgPath?: string
}
